import { AccordionView } from "common/views/accordion/Accordion.view";
import { CarouselView } from "common/views/carousel/Carousel.view";
import { RowsView } from "common/views/rows/Rows.view";
import DataTable from "common/views/table/DataTable";
import { Fragment, IDataFragment } from "core/components/FragmentProvider";
import Course from "panels/catalog/entities/Course";
import { ICourseParams } from "panels/catalog/entities/CourseParams";
import * as catalogActions from "../../catalogActions";
import ICourseFragmentProps from "../course/ICourseFragmentProps";

export interface IParentContainerFragmentProps {
	children?: JSX.Element[];
	courses: Course[];
	params: ICourseParams;
	renderItem: (course: Course, index?: number) => JSX.Element;
	renderExpand?: (course: Course) => JSX.Element;
	courseFragments: Array<IDataFragment<any>>;
	actions: typeof catalogActions;
}

function getKey(course: Course) { return course.id; }

export const rows: Fragment<IParentContainerFragmentProps> = {
	name: "Rows",
	component: ({courses, renderItem}) => (
		<RowsView
			items={courses}
			renderItem={renderItem}
			viewKey="courseList.container.rows"
		/>
	)
};

export const carousel: Fragment<IParentContainerFragmentProps> = {
	name: "Carousel / Slider",
	component: ({ courses, renderItem }) => {
		/**If data list is less than 4 then carousel is not required */
		if (courses && courses.length < 4) {
			return (<RowsView
			items={courses}
			renderItem={renderItem}
			viewKey="courseList.container.rows"
		/>)
		}
		return (
			<CarouselView
				items={courses}
				renderItem={renderItem}
				viewKey="courseList.container.carousel"
			/>
		)
	}
};

export const table: Fragment<IParentContainerFragmentProps> = {
	name: "Table",
	component: (props) => {
		const {courses, actions, courseFragments, params} = props;

		return (
			<DataTable
				data={courses}
				entity={Course}
				columns={courseFragments}
				getColumnProps={(dataItem: Course): ICourseFragmentProps => ({
					course: dataItem, actions, params,
					cartItems: [{ course: {} }],
					quantityInCart: [{ courseId: "", courseQuantity: 0 }],
				})}
				params={params as any}
				getId={getKey}
				viewKeyPrefix="courseTable"
			/>
		);
	}
};

export const accordion: Fragment<IParentContainerFragmentProps> = {
	name: "Accordion",
	component: ({courses, renderItem, renderExpand}) => (
		<AccordionView
			viewKey="courseList.container.accordion"
			items={courses}
			getId={getKey}
			renderItem={(item) => renderItem(item)}
			renderExpand={(item) => renderExpand(item)}
		/>
	)
};



// WEBPACK FOOTER //
// ./src/panels/catalog/fragments/container/parentContainerFragments.tsx